import resetStoreState from './resetStoreState';

const logic = [resetStoreState];

export default logic;
